<script>
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { ONLINE_EVENT_TYPES } from "%/constants/event-constants";

export default {
  name: "EventLocation",
  elementPanelSettings: {
    displayIcon: "address-book",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Location",
  },
  extends: TextElement,
  mixins: [EventCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    isOnlineEvent() {
      return ONLINE_EVENT_TYPES.includes(this.entity.eventType);
    },
    value() {
      const location = this.entity.location?.trim() || "";
      if (location) {
        return location;
      }
      return this.isOnlineEvent ? "Online" : "";
    },
  },
};
</script>
